// src/pages/Trader/OrdersAndWithdrawals/Settlements/page/Settlements.tsx
import React, { useState } from 'react';
import './Settlements.css';
import SelfRates   from '../../components/SelfRate/SelfRates';
import SelfStats   from '../../components/SelfState/SelfStats';
import { MainContainer } from '../../../../../components/MainContainer/MainContainer';
import { Content }       from '../components/Content/Content';
import {CreateSettlementsDeposit}   from '../components/CreateSettlementsDeposit/CreateSettlementsDeposit';
import {CreateSettlementsWithdrawal} from '../components/CreateSettlementsWithdrawal/CreateSettlementsWithdrawal';
import { DownloadSettlements } from '../components/DownloadSettlements/DownloadSettlements';
import CustomFilterModal, { FilterValues } from '../components/CustomFilterModal/CustomFilterModal';

export const Settlements: React.FC = () => {
  const [isDepositOpen,    setDepositOpen]    = useState(false);
  const [isWithdrawalOpen, setWithdrawalOpen] = useState(false);
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const [isFilterOpen,     setFilterOpen]     = useState(false);
  const [filterVals,       setFilterVals]     = useState<FilterValues | null>(null);

  return (
    <MainContainer>
      <div className="settlements merchant-page">
        <header className="merchant-page__header">
          <div>
            <span className="merchant-page__eyebrow">КОШЕЛЁК</span>
            <h1>Взаиморасчёты</h1>
            <p>Пополнения и выплаты по расчётному балансу</p>
          </div>
        </header>
        <SelfRates />
        <SelfStats />

        <div className="merchant-toolbar">
          <button
            className="merchant-button merchant-button--primary"
            onClick={() => setDepositOpen(true)}
          >
            + Пополнение
          </button>
          <button
            className="merchant-button merchant-button--danger"
            onClick={() => setWithdrawalOpen(true)}
          >
            + Выплата
          </button>
          <div className="merchant-toolbar__spacer" />

          <button
            type="button"
            onClick={() => setFilterOpen(true)}
            aria-label="Фильтр"
            className="merchant-icon-button"
          >
            <img
              src="/filter.svg"
              alt="Фильтр"
              className="merchant-icon-button__image"
            />
          </button>

          <button
            type="button"
            onClick={() => setIsDownloadOpen(true)}
            aria-label="Скачать"
            className="merchant-icon-button"
          >
            <img
              src="/download.svg"
              alt="Скачать"
              className="merchant-icon-button__image"
            />
          </button>
        </div>
        <h2 className="merchant-section-title">Заявки взаиморасчётов</h2>

        <Content filter={filterVals} />

        <CreateSettlementsWithdrawal
          open={isWithdrawalOpen}
          onClose={() => setWithdrawalOpen(false)}
        />
        <CreateSettlementsDeposit
          open={isDepositOpen}
          onClose={() => setDepositOpen(false)}
        />
        <DownloadSettlements
        open={isDownloadOpen}
        onClose={() => setIsDownloadOpen(false)}
        />

        <CustomFilterModal
          isOpen={isFilterOpen}
          onClose={() => setFilterOpen(false)}
          onApply={vals => {
            setFilterVals(vals);
            setFilterOpen(false);
          }}
        />

      </div>
    </MainContainer>
  );
};

export default Settlements;
